import { ComponentType } from 'react'

import { LTProgramName } from '@lyrahealth-inc/shared-app-logic/src/models/programs/Programs'
import { AlcoholUseDisorderTherapyIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/AlcoholUseDisorderTherapyIcon'
import { BlendedCareMedicineIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/BlendedCareMedicineIcon'
import { BlendedCareTherapyIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/BlendedCareTherapyIcon'
import { ClinicalLeaveEvaluationIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/ClinicalLeaveEvaluationIcon'
import { CoachingIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/CoachingIcon'
import { DialecticalBehavioralTherapyIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/DialecticalBehavioralTherapyIcon'
import { SingleSessionCoachingIcon } from '@lyrahealth-inc/ui-core-crossplatform/src/atoms/icons/SingleSessionCoachingIcon'

import { programConfig } from './appConstants'

export const programIconMap = {
  AlcoholUseDisorderTherapyIcon,
  BlendedCareTherapyIcon,
  CoachingIcon,
  SingleSessionCoachingIcon,
  BlendedCareMedicineIcon,
  ClinicalLeaveEvaluationIcon,
  DialecticalBehavioralTherapyIcon,
}

// BlendedCareMedicineIcon and ClinicalLeaveEvaluationIcon take `tooltipLabel`, so they ignore `tooltip`
type ProgramIconProps = { width?: number; height?: number; tooltip?: string }

export const getProgramIcon = (programName: string): ComponentType<ProgramIconProps> | undefined => {
  const icon = programConfig[programName as LTProgramName]?.icon
  return icon ? programIconMap[icon as keyof typeof programIconMap] : undefined
}
